module.exports = "<section class=\"banner-landing v1\">\r\n    <div class=\"container\">\r\n        <advertisement ng-if=\"$ctrl.cmsData.carrusel.images[1]\" sh-ctrl=\"$ctrl.shCtrl\" type-content=\"adaptative\"\r\n                       positions=\"1\" content-data=\"$ctrl.cmsData\"></advertisement>\r\n    </div>\r\n</section>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/landing/templates/landing-adaptative.html
 ** module id = 641
 ** module chunks = 0
 **/